import React from 'react';
// import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
// import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaXTwitter } from 'react-icons/fa';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import DownloadQrCode from '../QrCode/DownloadQrCode';
// import { FaXTwitter } from 'react-icons/fa6';



function WidgetAbout({ text, linkedInLink, fbLink, twitterLink, instaLink, youtubeLink }) {
    return (
        <>
            <div className="col-md-6 col-xl-4 col-12">
                <div className="single-footer-wid d-flex flex-column align-items-xl-end justify-content-between gap-4">
                    {/* <div className="wid-title">
                    </div> */}
                    {/* <p>{text}</p> */}
                    <div className="social_link">
                        <h6 className='mb-2 footer-title-text'>Connect with Us:</h6>
                        <div className='d-flex'>
                            <a href={linkedInLink} target='_blank'>
                                <FaLinkedinIn/>
                            </a>
                            <a href={fbLink} target='_blank'>
                                <FaFacebookF />
                            </a>
                            {/* <a href={twitterLink} target='_blank'>
                                <FaXTwitter/>
                            </a> */}
                            <a href={instaLink} target='_blank'>
                                <FaInstagram />
                            </a>
                            <a href={youtubeLink} target='_blank'>
                                <FaYoutube />
                            </a>
                        </div>
                    </div>
                    <DownloadQrCode size={150}/>

                </div>
            </div>
        </>
    );
}

export default WidgetAbout;
